import React,{ PureComponent} from 'react'
import {Form, Input, Button, Radio, DatePicker, Select, } from 'antd';
import PropTypes from 'prop-types';
import {trim, isEmpty,sortBy} from '@utils/utils';
import Lang from "@/components/Lang/Lang";
import SearchFromRegion from '@/components/Region/SearchFromRegion';
import WarehouseSelect from '@/components/WarehouseSelect/WarehouseSelect';
import CommonSelect from '../FormFormat/CommonSelect';
import './SearchForm.less'
import dayjs from "dayjs";
const { Search } = Input;
const FormItem = Form.Item;
const {  RangePicker } = DatePicker;
const Option = Select.Option;
/**
 * 搜索表格 回调Form数据
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 * @ 必传参数
 * options 选项内容  [{
         * name:                返回的Key,
         * cnTitle              国际化显示文字，默认值，优选      ** 不填 此两项数据默认无标签
         * cnTitleId            国际化KEY值                       ** 不填 此两项数据默认无标签
         * cnPlaceholder        默认显示文字国际化默认值，
         * cnPlaceholderId      默认显示文字国际化KEY值
         * hiddenLabel          选填，默认false,显标签
         * col                  选填, col 点比, 默认null, 内容框升高为240，可设置width，如下
         * width                选填，input宽度
         * canSearch            Enum Select等配置，选填，默认false,为true时直接过滤当前值，搜索
 * }]
 *
 * type: 默认 普通输入框
 *      -  DateRangePicker 时间范围组件
 *      -  SearchInput 搜索按钮
 *      -  Enum：枚举下拉 : 需要傳入enumClass對應字典,有 (excludeValue[]) 时排除数组中的code，
 enumSort:以id为基础ASC表示升序排序,DESC表示降序排序
 *      -  Month：月份选择组件
 *      -  SearchSelect：选择下拉组件
 *      -  Radio：单选组(读取options或者radioClass字典),可配置 change，回调选中数据
 *
 *
 * @ 选传参数
 * flagShowReset        是否显示重置按钮,默认 true，重置同时触发 getSearchValue 事件
 * flagShowSearchBtn    是否显示搜索按钮，如果配置有搜索按钮Input，最好将此项设为true,不然有两个搜索事件
 * searchLeft           搜索表单 左则内容
 * setLeft              自定义左则内容(跟在搜索表单后)
 * setRight             自定义右则内容
 * initialValues        默认值(object)
 *
 * @ 方法
 * getSearchValue       回调Form数据
 * searchReset          回调重置方法，谨传，传此方法请自行处理重置数据逻辑
 * partRow 一行几列，传数字
 *
 *
 *  handleChange 暂仅支持配置枚举使用，如果传入方法，行编修改枚举组件值时触发此方法 *
 *
 **/
class SearchForm extends PureComponent {
    static propTypes = {
        options: PropTypes.array,
        getSearchValue: PropTypes.func,
        flagShowReset: PropTypes.bool,
        flagShowSearchBtn: PropTypes.bool,
        setRight:PropTypes.any,
        setLeft:PropTypes.any,
        colon: PropTypes.bool,
        partRow:PropTypes.number,
        col:PropTypes.number,
        formItemLayout: PropTypes.object,
        className:PropTypes.string,
        initialValues: PropTypes.object, //默认值
    }
    static defaultProps = {
        options: [],
        flagShowReset: true,
        flagShowSearchBtn: true,
        setRight:null,
        setLeft:null,
        colon:false,
        partRow:null,
        col: null,
        formItemLayout:null,
        className:null,
        initialValues:null,
    };
    constructor(props) {
        super(props);
        this.state = {
            currSearch:{}
        }
    }
    formRef = React.createRef();
    /**
     * 获取当前数据
     ***/
    handleSearch =async() =>{
        let values = await this.formRef.current.validateFields();
        const { options } = this.props;
        options.forEach(item=>{
            if(item.type == "DateRangePicker" && values[item.name]){
              //  console.log("DateRangePicker",values[item.name])
                const curValue = values[item.name];
                let { currSearch={} }= this.state;
                const day1 = dayjs(curValue[0]).startOf('date').valueOf(); //开始时间
                const day2 = dayjs(curValue[1]).add(1, 'days').startOf('date').valueOf(); //结束时间
                if(item.searchRange&&item.searchRange[0]){
                    currSearch[item.searchRange[0]] = day1;
                    values[item.searchRange[0]] = day1;
                }
                if(item.searchRange&&item.searchRange[1]){
                    currSearch[item.searchRange[1]] = day2;
                    values[item.searchRange[1]] = day2;
                }
                this.setState({
                    currSearch : currSearch
                })
            }
        })
        // 统一处理空值
        let map = {}
        for(let key in values){
            if(!isEmpty(values[key]))map[key] = typeof values[key]=='string'?trim(values[key]):values[key];
        }
        this.props.getSearchValue(map);
    }
    getSearchFromValue =async() =>{
        let values = await this.formRef.current.validateFields();
        const { options } = this.props;
        options.forEach(item=>{
            if(item.type == "DateRangePicker" && values[item.name]){
                const curValue = values[item.name];
                let { currSearch={} }= this.state;
                const day1 = dayjs(curValue[0]).startOf("date").valueOf(); //开始时间
                const day2 = dayjs(curValue[1]).endOf("date").valueOf(); //结束时间
                if(item.searchRange[0]){
                    currSearch[item.searchRange[0]] = day1;
                    values[item.searchRange[0]] = day1;
                }
                if(item.searchRange[1]){
                    currSearch[item.searchRange[1]] = day2;
                    values[item.searchRange[1]] = day2;
                }
                this.setState({
                    currSearch : currSearch
                })
            }
        })
        return values
    }
    /**
     * 单独搜索
     *
     **/
    singleSearch(data,key){
        let { currSearch={} }= this.state;
        currSearch[key] = data;
        this.setState({
            currSearch : currSearch
        })
        this.props.getSearchValue(currSearch);
    }
    onPressEnterSearch(e,key){
        const { target } = e;
        const data = target?target.value:'';
        this.singleSearch(data,key);
    }
    handleReset = () => {
        this.formRef.current.resetFields();
        if(this.props.searchReset){
            this.props.searchReset();
        }else this.props.getSearchValue();
    }
    renderOptions(options){
        let optionsChildren = [];
        options.map((item,inx) =>{
            if(item){
                optionsChildren.push(this.renderOptionType(item));
            }else return null
        });
        return optionsChildren
    }
    /**
     * 输出select
     * */
    getEnumClass(enumClass='',excludeValue=[],enumSort=""){
        let list = __getDictList(enumClass)||[];
        if(!isEmpty(enumSort)&&list.length>0){
            // ASC表示升序排序,DESC表示降序排序
             list = list.sort(sortBy('id',enumSort=="ASC"?true:false));
        }
        const enumChildren = [];
        list.map(item=>{
            if(!excludeValue.includes(item.code))enumChildren.push(<Option key={item.id} value={item.code}>{item.name}</Option>)
        });
        return enumChildren;
    }
    /***
     * 清除字段值 | 设置字段
     * 外部接口可用，单独清理一个值
     */
    setField(field='',value=undefined){
        if(field){
            let obj = {};
            obj[field] = value
            this.formRef.current.setFieldsValue(obj);
            let {currSearch = {}} = this.state;
            currSearch[field] = value;
            this.setState({
                currSearch:currSearch
            })
        }
    }
    /**
     * 时间范围搜索按钮
     * item.canSearch
     **/
    datePackerSearch=(canSearch=false,date=[],dateString=[],key=[])=>{
        if(canSearch){
            let { currSearch={} }= this.state;
            const day1 = dayjs(dateString[0]).startOf("date").valueOf(); //开始时间
            // const day2 = dayjs(dateString[1]).add(1, 'days').valueOf(); //结束时间
            const day2 = dayjs(dateString[1]).endOf("date").valueOf(); //结束时间
            if(key[0])currSearch[key[0]] = day1
            if(key[1])currSearch[key[1]] = day2;
            this.setState({
                currSearch : currSearch
            })
            this.props.getSearchValue(currSearch);
        }
    }
    // 输出 类型
    renderOptionType(item){
        let config = {
            name: item.name,
            key: item.name,
        }
        const langShowText = item.cnTitleId&&item.cnTitleId?Lang({id:item.cnTitleId,default:item.cnTitle}):item.title||'';
        const langPlaceholderText = item.cnPlaceholderId&&item.cnPlaceholderId.constructor == Array ?
            (item.cnPlaceholderId&&item.cnPlaceholderId.length>1?[Lang({id:item.cnPlaceholderId[0],default:item.cnPlaceholder[0]}),Lang({id:item.cnPlaceholderId[1],default:item.cnPlaceholder[1]})]:item.title||Lang({id:"QingShuRu", default:"请输入"}))
        :(item.cnPlaceholderId?Lang({id:item.cnPlaceholderId,default:item.cnPlaceholder}):item.title||Lang({id:"QingShuRu", default:"请输入"}));

        if(!item.hiddenLabel&&langShowText){
            config["label"]  = <span className="label-txt">{langShowText}</span>
        }
        switch (item.type) {
            case 'WarehouseSelect':
                return (<div className={"rowSearch"} key={item.name} style={!isEmpty(item.width)?{'width':item.width+'px'}:{}}>
                <FormItem {...config}>
                    <WarehouseSelect />
                </FormItem>
            </div>);
            case 'Radio':
                if((!item.options||item.options.length==0)&&item.radioClass){
                    const list = __getDictList(item.radioClass) || [];
                    item.options = [];
                    list.forEach(dict=>{
                        item.options.push({
                            value: item.valueKey?dict[item.valueKey]:dict.code,
                            title:dict.name,
                        })
                    })
                }
                return (<div className={"rowSearch"} key={item.name} style={!isEmpty(item.width)?{'width':item.width+'px'}:{}}>
                    <FormItem {...config}>
                        <Radio.Group disabled={item.disabled} onChange={(e)=>item.change?item.change(e.target):null}>
                            {item.options&&item.options.map((opt,rInx)=><Radio.Button key={opt.value+"_"+rInx} value={opt.value+''}>{opt.title||__getServerLanguage(opt.cnTitleId)}</Radio.Button>)}
                        </Radio.Group>
                    </FormItem>
                </div>);
            case 'SearchSelect':
                const searchClass = item.searchClass||{};
                return (<div className={"rowSearch"} key={item.name} style={!isEmpty(item.width)?{'width':item.width+'px'}:{}}>
                    <FormItem {...config}>
                    <CommonSelect placeholder={langPlaceholderText}
                                  onOtherChange={(value)=>{item.canSearch&&this.singleSearch(value,item.name)}}
                                  api={searchClass.api}
                                  precondition={searchClass.precondition||{}}
                                  nameField={searchClass.nameField}
                                  idField={searchClass.idField} />
                </FormItem>
                </div>);
            case 'Enum':
                return (<div className={"rowSearch"} key={"Enum_"+item.name} style={!isEmpty(item.width)?{'width':item.width+'px'}:{}}>
                    <FormItem {...config}>
                     <Select placeholder={langPlaceholderText}
                             onChange={(value)=>{item.canSearch&&this.singleSearch(value,item.name)}}
                             allowClear={item.allowClear} >
                            {item.enumCanAll&&<Option value="">{item.enumCanAllTitle||Lang({id: 'QuanBu', default: '全部'})}</Option>}
                            {!isEmpty(item.enumClass)&&this.getEnumClass(item.enumClass,item.excludeValue,item.enumSort)}
                        </Select>
                    </FormItem>
                </div>);
            case 'Region':
                return (<SearchFromRegion key={item.name}
                                required={item.required}
                                disabled={item.disabled}
                                title={langShowText} //标题
                                name={item.name}
                                initValue={item.value||{}}
                                showSubTitle={item.showSubTitle}
                                clearSubRegion={(v)=>this.setField(v)} />)
            case 'Month':
                return (<FormItem {...config} className={"rowSearch"} key={item.name}>
                    <DatePicker picker="month" placeholder={langPlaceholderText} allowClear={item.allowClear} />
                </FormItem>);
            case 'DateRangePicker':
                return (<FormItem {...config} key={item.name} className={"rowSearch"} style={!isEmpty(item.width)?{'width':item.width+'px'}:{}}>
                    <RangePicker placeholder={[Lang({id:"KaiShiShiJian", default: '开始时间'}), Lang({id:"JieShuShiJian",default:"结束时间"})]}
                                 allowClear={item.allowClear===false?false:true}
                                 style={!isEmpty(item.width)?{'width':item.width+'px'}:{}}
                                 disabledDate={(currentDate)=>item.disabledDate?item.disabledDate(currentDate):""}
                                 onChange={(date,dateString)=>this.datePackerSearch(item.canSearch,date,dateString,item.searchRange)}
                    />
                </FormItem>);
            case 'SearchInput':
                return (<div className={"rowSearch"} key={"SearchInput_"+item.name} style={!isEmpty(item.width)?{'width':item.width+'px'}:{}}>
                    <Form.Item {...config}>
                        <Search name={item.name}
                                allowClear
                                placeholder={langPlaceholderText}
                                onPressEnter={(e)=>this.onPressEnterSearch(e,item.name)}
                                onSearch={(data)=>this.singleSearch(data,item.name)}
                        />
                    </Form.Item>
                </div>);
            default:
                return (<div className={"rowSearch"}  key={item.name} style={!isEmpty(item.width)?{'width':item.width+'px'}:{}}>
                    <FormItem {...config} >
                        <Input placeholder={langPlaceholderText} allowClear />
                    </FormItem>
                </div>);
        }
    }
    // 加载
    componentDidMount() {
        if( this.props.onRef)  this.props.onRef(this);
    };
    render() {
        const { options, flagShowReset,searchLeft, setLeft,setLeftBtnRight,setRight,flagShowSearchBtn,colon,formItemLayout,className,initialValues } = this.props;
        return (
            <Form {...formItemLayout} className={className?className:"search-form search-form-white"} ref={this.formRef} autoComplete={'off'} colon={colon} initialValues={initialValues}>
                    {(options&&options.length>0||searchLeft||setLeft)&&<div className={"flex-item"} key={"search-form-left"}>
                        {searchLeft&&<span>{searchLeft}</span>}
                        {this.renderOptions(options)}
                        {setLeft&&<>{setLeft}</>}
                        <div className={'btn-action mb_12'}>
                            {flagShowSearchBtn&&<Button type="primary" htmlType="submit" onClick={()=>this.handleSearch()}>{Lang({id:'SouSuo', default:'搜索'})}</Button>}
                            {flagShowReset&&<Button type="text" className={"ml_4"} onClick={()=>this.handleReset()}>
                                {Lang({id: 'ZhongZhi', default: '重置'})}
                            </Button>}
                        </div>
                        {setLeftBtnRight&&<>{setLeftBtnRight}</>}
                    </div>}
                    {setRight&&<div key={"search-form-right"}>
                        {setRight}
                    </div>}
            </Form>
        );
    }
}
export default SearchForm;